<template>
  <v-dialog v-model="dialogStatus" max-width="900" transition="dialog-bottom-transition">
    <v-card class="mx-auto window-card">
      <div class="d-flex align-end mb-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <v-icon color="white"> mdi-bookmark </v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">类型详情</span>
      </div>

      <v-card-text class="pa-4">
        <v-form v-model="valid">
          <v-card>
            <v-tabs v-model="tab" background-color="green" center-active dark>
              <v-tab key="tab-base">基础属性</v-tab>
              <v-tab key="tab-ext">扩展属性</v-tab>
              <v-tab key="tab-act">动作定义</v-tab>
              <v-tab key="tab-int">界面管理</v-tab>
            </v-tabs>
          </v-card>

          <v-tabs-items v-model="tab">
            <v-tab-item class="pa-3" key="tab-base">
              <BaseTab v-if="dialogStatus" ref="tab-base" />
            </v-tab-item>
            <v-tab-item key="tab-ext">
              <ExtTab v-if="dialogStatus" ref="tab-ext" />
            </v-tab-item>
            <v-tab-item key="tab-act">
              <ActTab v-if="dialogStatus" ref="tab-act" />
            </v-tab-item>
            <v-tab-item key="tab-int">
              <IntTab v-if="dialogStatus" ref="tab-int" />
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" type="submit" @click.stop="confirm" :disabled="course_senior">确 定</v-btn>
        <v-btn color="gray" @click="cancel">关 闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import ActTab from './TypeDetail/ActTab.vue';
import BaseTab from './TypeDetail/BaseTab';
import ExtTab from './TypeDetail/ExtTab';
import IntTab from './TypeDetail/IntTab';
import { getCourseById } from '@/api/course';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['showType']),
    dialogStatus: {
      get() {
        return this.showType !== 'close';
      },
      set(val) {
        if (!val) {
          this.handleChangeStatus('close');
        }
      },
    },
  },
  components: {
    ActTab,
    BaseTab,
    ExtTab,
    IntTab,
  },
  data() {
    return {
      tab: 'tab-base',
      valid: false,
      course_senior:false,
    };
  },
  created(){
    this.queryCourse()
  },
  methods: {
    confirm() {
      // 保存
      this.$store.dispatch('editorType/saveTypeInfo', this.$route.params);
    },
    handleChangeStatus(status) {
      this.$store.dispatch('editorType/reverseShowTypeStatus', status);
    },
    cancel() {
      this.handleChangeStatus('close');
    },
    getUserId(){
      let userId = ''
        if(window.localStorage.getItem('USER_INFO')){
          let data = JSON.parse(window.localStorage.getItem('USER_INFO'))
           userId = data.user._id
        }else{
          userId = ''
        }
        return userId
    },
    queryCourse(){

      if(this.$route.params.courseId){
        getCourseById(this.$route.params.courseId).then(res=>{
          if(res.data){
            //  if(res.data.hasAuthModify){  //自己创建的课程和协作课程 true 可以修改并且查看
            //     this.course_senior = false;  //不禁用
            //  }else{  //不是自己创建的课程 如果是普通模式//禁用  
            //           if(res.data.is_senior==false){  //普通模式
            //             this.course_senior = true;    
            //         }else{      //高级模式  可以查看并且修改
            //             this.course_senior = false;  
            //         }
            //  }
            if (res.data.hasAuthModify) {
              //自己创建的课程和协作课程 true 可以修改并且查看
              // this.course_senior = false; //不禁用
              if (res.data.is_senior == false) {
                  //普通模式
                  this.course_senior = true;
                } else {
                  //高级模式
                  this.course_senior = false;
                }

            } else {
              //不是自己创建的课程 如果是普通模式//禁用

              if (res.data.is_open == true) {
                this.course_senior = true; //公开课程禁用 只能查看
              } else {
                if (res.data.is_senior == false) {
                  //普通模式
                  this.course_senior = true;
                } else {
                  //高级模式
                  this.course_senior = false;
                }
              }
            }
          }

  

      })
    }

    }
  },
};
</script>
<style>
</style>